import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { money, gradient } from "@/lib/format";
import { Leaf, ShoppingBag } from "lucide-react";

export default function CustomerDisplay() {
  const { token } = useParams();
  const [cart, setCart] = useState({ items: [], total: 0, discount: 0, subtotal: 0 });

  useEffect(() => {
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/pos/display/${token}`);
        if (alive && data?.cart) setCart(data.cart);
      } catch {}
    };
    poll();
    const t = setInterval(poll, 1500);
    return () => { alive = false; clearInterval(t); };
  }, [token]);

  const items = cart.items || [];
  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col">
      <div className={`${gradient} px-8 py-6 flex items-center gap-3`}>
        <Leaf className="w-8 h-8" />
        <span className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>HA Grove ST</span>
      </div>
      <div className="flex-1 p-8 overflow-auto" data-testid="customer-display-cart">
        {items.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-slate-500">
            <ShoppingBag className="w-16 h-16 mb-4" />
            <p className="text-2xl">Welcome — your items will appear here</p>
          </div>
        ) : (
          <div className="max-w-3xl mx-auto space-y-3">
            {items.map((it, i) => (
              <div key={i} className="flex justify-between items-center bg-slate-900 rounded-xl px-6 py-4 text-xl">
                <span>{it.name} {it.qty > 1 ? `× ${it.qty}` : ""}</span>
                <span className="font-semibold">{money(it.unit_price * it.qty)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="border-t border-slate-800 p-8">
        <div className="max-w-3xl mx-auto space-y-2">
          {cart.discount > 0 && (
            <div className="flex justify-between text-lg text-emerald-400">
              <span>Discounts</span><span>-{money(cart.discount)}</span>
            </div>
          )}
          <div className="flex justify-between items-center">
            <span className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Total</span>
            <span className="text-5xl font-bold text-emerald-400" data-testid="customer-display-total">{money(cart.total)}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
